import AddResourceForm from "Forms/AddResourceForm";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";

class LinksFormModal extends Component {
  state = {
    error: null,
    success: false,
    fetching: false
  };

  /**
   * TODO: Enable user links
   */

  async componentDidMount() {
    const { getResources } = this.props;
    await getResources();
  }

  handleSubmit = async values => {
    const { addProjectResources, projectId } = this.props;
    const data = {
      values,
      project: projectId
    };

    this.setState({ fetching: true });

    const resolve = {
      onSuccess: () => {
        this.setState({
          error: null,
          success: true,
          fetching: false
        });
      },
      onFailure: e => {
        console.log("Error", e);
        this.setState({
          error: e.message,
          success: false,
          fetching: false
        });
      }
    };
    await addProjectResources(data, resolve);
  };

  render() {
    const { show, onHide, projectResources, resources, customIcon } = this.props;
    const { error, success, fetching } = this.state;
    return (
      <Modal size="lg" dialogClassName="modal-90w" show={show} onHide={onHide}>
        <Modal.Header closeButton>Add Links</Modal.Header>
        <Modal.Body>
          <AddResourceForm
            resources={resources}
            handleSubmit={this.handleSubmit}
            addedResources={projectResources}
            error={error}
            success={success}
            fetching={fetching}
            customIcon={customIcon}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    projectResources: ProjectSelectors.getProjectResources(state),
    resources: ProjectSelectors.getResources(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProjectResources: data =>
      dispatch(ProjectActions.projectResourcesRequest(data)),
    addProjectResources: (data, resolve) =>
      dispatch(ProjectActions.addResourcesRequest(data, resolve)),
    getResources: () => dispatch(ProjectActions.getResourcesRequest()),

  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LinksFormModal);
